import gameNames from '../../hub/data/GameIds';

const initialState = {
  // array of ids of items to be highlighted
  highlightedItemsIds: [],
};

const highlightedItemsReducer = (state = initialState, action) => {
  if (action.gameId !== gameNames.SUPER_MATCH) {
    return state;
  }

  switch (action.type) {
    case 'HIGHLIGHT_ITEMS':
      return {
        ...state,
        highlightedItemsIds: action.payload.highlightedItemsIds,
      };
    case 'RESET_HIGHLIGHTED_ITEMS':
      return { highlightedItemsIds: [] };
    default:
      return state;
  }
};

export default highlightedItemsReducer;
